module.exports = __webpack_public_path__ + "img/03 Aniamtion 3-squashed.3240ba91.jpg";